function copyToClipboardDeprecated(value) {
    let temp = document.createElement('textarea');
    temp.value = value;
    document.body.appendChild(temp);
    temp.select();
    document.execCommand('copy');
    document.body.removeChild(temp);
}

export function copyToClipboard (value) {
    if (!navigator.clipboard || !navigator.permissions || (window.location.protocol === 'http:' && window.location.hostname !== 'localhost')) {
        // Use the deprecated method if we are in a browser that doesnt support the clipboard API
        // Also, clipboard API only works on HTTPS except for 'localhost' which works on HTTP
        copyToClipboardDeprecated(value);

        return new Promise((resolve,reject) => {
            resolve();
        });
    } else {
        //
        return navigator.permissions.query({ name: "clipboard-write" }).then((result) => {
            if (result.state === "granted" || result.state === "prompt") {
                return navigator.clipboard.writeText(value);
            }

            throw new Error('No access to clipboard');
        }).catch((err) => {
            // If we had an error using the clipboard api, lets try fall-back to the deprecated method
            copyToClipboardDeprecated(value);
        })
    }
}